import { VueModule } from '@Foundation/utilities';
import DynamicLinks from './code/Scripts/components/dynamic-links.vue';

export default VueModule({
    components: {
        DynamicLinks
    }})